export interface InventoryTransfer {
  comment?: string;
  from_warehouse_uuid?: string;
  movement_type: MovementType;
  supplies: InventoryTransferSupply[];
  to_warehouse_uuid?: string;
  urls?: string[];
}

interface InventoryTransferSupply {
  quantity: number;
  uuid: string;
}

export enum MovementTypeNames {
  "entry" = "Entrada",
  "exit" = "Salida",
  "sale" = "Venta",
  "sale_cancel" = "Cancelación",
  "transfer" = "Transferencia",
  "adjustment_positive" = "Ajuste",
  "adjustment_negative" = "Ajuste",
  "waste" = "Merma",
}

export type MovementType =
  | "entry"
  | "exit"
  | "sale"
  | "sale_cancel"
  | "transfer"
  | "adjustment_positive"
  | "adjustment_negative"
  | "waste";

export interface InventoryTransferResponse {
  data: null;
  error_code: string;
  http_code: number;
  is_success: boolean;
  message: string;
  type: string;
}
